/* eslint-disable security/detect-non-literal-fs-filename */
import './CommentDisplaySection.style.less'
import { Avatar, Card, Comment, Popover } from 'antd'
import Meta from 'antd/lib/card/Meta'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { getCommentDisplayElement } from '../../CommentFieldDialog.helper'
import { ICommentDataField } from '../../CommentFieldDialog.interface'
import CommentFieldInput from '../CommentFieldInput/CommentFieldInput'
import { find, get, last, orderBy } from 'lodash'
import {
  MailOutlined,
  PaperClipOutlined,
  PhoneOutlined,
} from '@ant-design/icons'
import { queryClient } from '@/config/react-query'
import { isEmptyValue } from '@/utils/common'

interface Prop {
  data: ICommentDataField
  task: any
  taskId: string
  section: 'all' | 'byOrderId'
  onReload: () => any
}

function CommentDisplaySection(props: Prop) {
  const { data: _comments, task, taskId } = props as any
  const [collapse, setcollapse] = useState(false)
  function _renderFile(file: {
    name: string
    size: number
    url_path: string
    created_at: string
  }) {
    return (
      <div
        className="comment-file"
        onClick={() => {
          window.open(file?.url_path, '_blank')
        }}
      >
        <div className="comment-file-container">
          <PaperClipOutlined />
          <div className="comment-file-name">{file?.name}</div>
        </div>
      </div>
    )
  }

  function _renderFileList(
    fileData: {
      name: string
      size: number
      url_path: string
      created_at: string
    }[]
  ) {
    if (!fileData && !fileData?.length) return <></>
    return (
      <div className="files">
        {fileData.map((file) => {
          return _renderFile(file)
        })}
      </div>
    )
  }

  useEffect(() => {
    props.onReload()
  }, [])

  return (
    <div className="comment-container" id={_comments.id}>
      <Comment
        className={`custom-comment  ${
          _comments?.children?.length && 'has-child'
        }`}
        author={
          <div>
            <span className="comment-name">
              {_comments?.created_by?.first_name}{' '}
              {_comments?.created_by?.last_name}
              <br />
              <span className="comment-date">
                {moment(_comments?.created_date).format(
                  'DD MMM yyyy - hh:mm A'
                )}
              </span>
            </span>
          </div>
        }
        actions={
          !collapse &&
          get(_comments?.children, 'length', 0) === 0 && [
            <>
              <span
                className="comment-reply"
                onClick={() => {
                  setcollapse(!collapse)
                }}
              >
                Reply
              </span>
            </>,
          ]
        }
        avatar={
          <Popover
            placement="bottom"
            content={
              <div className="comment-user-popover-name">
                <Card className="p-2" bordered={false}>
                  <Meta
                    avatar={
                      <Avatar src={_comments?.created_by?.avatar?.url_path}>
                        {`${_comments?.created_by?.first_name.charAt(
                          0
                        )}${_comments?.created_by?.last_name.charAt(0)}`}
                      </Avatar>
                    }
                    title={`${_comments?.created_by?.first_name} ${_comments?.created_by?.last_name}`}
                  />

                  <div style={{ marginTop: 15 }}>
                    <p>
                      <PhoneOutlined /> &nbsp;
                      <a
                        href={`tel:${
                          find(_comments?.created_by?.property_value?.value, [
                            'key',
                            'phoneNumber',
                          ])?.value ?? 'N/A'
                        }`}
                      >
                        {find(_comments?.created_by?.property_value?.value, [
                          'key',
                          'phoneNumber',
                        ])?.value ?? 'N/A'}
                      </a>
                    </p>

                    <p>
                      <MailOutlined /> &nbsp;
                      <a href={`mailto:${_comments?.created_by?.email ?? ''}`}>
                        {_comments?.created_by?.email ?? ''}
                      </a>
                    </p>
                  </div>
                </Card>
              </div>
            }
          >
            {_comments?.created_by?.avatar?.url_path ? (
              <Avatar
                src={_comments?.created_by?.avatar?.url_path ?? ''}
                alt={`${_comments?.created_by?.first_name} ${_comments?.created_by?.last_name}`}
              >
                {`${_comments?.created_by?.first_name} ${_comments?.created_by?.last_name}`}
              </Avatar>
            ) : (
              <Avatar
                alt={`${_comments?.created_by?.first_name} ${_comments?.created_by?.last_name}`}
              >
                {`${_comments?.created_by?.first_name.charAt(
                  0
                )}${_comments?.created_by?.last_name.charAt(0)}`}
              </Avatar>
            )}
          </Popover>
        }
        content={
          <>
            <p className="comment-text">
              {getCommentDisplayElement(
                _comments?.json_value?.comment,
                _comments?.json_value?.mentions,
                task
              )}
            </p>
            {_renderFileList(_comments?.json_value?.files)}
          </>
        }
      >
        <div className="child-comment-wrapper">
          {!isEmptyValue(_comments?.children) && <hr />}
          {_comments?.children &&
            orderBy(_comments.children, ['created_date'], ['asc']).map(
              (_child, _index) => {
                return (
                  <Comment
                    key={_index}
                    className="child-comment-container"
                    author={
                      <>
                        <span className="comment-name">
                          {_child?.created_by?.first_name}{' '}
                          {_child?.created_by?.last_name}
                          <br />
                          <span className="comment-date">
                            {moment(_child?.created_date).format(
                              'DD MMM yyyy - hh:mm A'
                            )}
                          </span>
                        </span>
                      </>
                    }
                    actions={
                      !collapse &&
                      _child ===
                        last(
                          orderBy(_comments.children, ['created_date'], ['asc'])
                        ) && [
                        <>
                          <span
                            className="comment-reply"
                            onClick={() => {
                              setcollapse(!collapse)
                            }}
                          >
                            Reply
                          </span>
                        </>,
                      ]
                    }
                    avatar={
                      <>
                        <Popover
                          placement="bottom"
                          content={
                            <div className="comment-user-popover-name">
                              <Card className="p-2" bordered={false}>
                                <Meta
                                  avatar={
                                    <Avatar
                                      src={_child.created_by?.avatar?.url_path}
                                    >
                                      {_child.created_by?.first_name}
                                    </Avatar>
                                  }
                                  title={`${_child.created_by?.first_name} ${_child.created_by?.last_name}`}
                                />
                                <div style={{ marginTop: 15 }}>
                                  <p>
                                    <PhoneOutlined /> &nbsp;
                                    <a
                                      href={`tel:${
                                        find(
                                          _child.created_by?.property_value
                                            ?.value,
                                          ['key', 'phoneNumber']
                                        )?.value ?? 'N/A'
                                      }`}
                                    >
                                      {find(
                                        _child.created_by?.property_value
                                          ?.value,
                                        ['key', 'phoneNumber']
                                      )?.value ?? 'N/A'}
                                    </a>
                                  </p>

                                  <p>
                                    <MailOutlined /> &nbsp;
                                    <a
                                      href={`mailto:${
                                        _child.created_by?.email ?? ''
                                      }`}
                                    >
                                      {_child.created_by?.email ?? ''}
                                    </a>
                                  </p>
                                </div>
                              </Card>
                            </div>
                          }
                        >
                          {_child?.created_by?.avatar?.url_path ? (
                            <Avatar
                              src={_child?.created_by?.avatar?.url_path ?? ''}
                              alt={`${_child?.created_by?.first_name} ${_child?.created_by?.last_name}`}
                            >
                              {`${_child?.created_by?.first_name} ${_child?.created_by?.last_name}`}
                            </Avatar>
                          ) : (
                            <Avatar
                              alt={`${_child?.created_by?.first_name} ${_child?.created_by?.last_name}`}
                            >
                              {`${_child?.created_by?.first_name.charAt(
                                0
                              )}${_child?.created_by?.last_name.charAt(0)}`}
                            </Avatar>
                          )}
                        </Popover>
                      </>
                    }
                    content={
                      <div className="comment-text">
                        <p>
                          {getCommentDisplayElement(
                            _child?.json_value?.comment,
                            _child?.json_value?.mentions,
                            task
                          )}
                        </p>
                        {_renderFileList(_child?.json_value?.files)}
                      </div>
                    }
                  />
                )
              }
            )}
        </div>
      </Comment>
      {collapse && (
        <div className="comment-input-container">
          <CommentFieldInput
            type="reply"
            onClose={() => setcollapse(false)}
            data={task as any}
            taskId={taskId}
            parentId={_comments?.id}
            section={props.section}
            onReload={async () => {
              props.onReload()
              await queryClient.refetchQueries(['GET_COMMENT_COUNT', taskId])
            }}
          />
        </div>
      )}
    </div>
  )
}

export default CommentDisplaySection
